import React from 'react';
import { InputWrapper } from 'form/components';
import { FormInput } from 'form/FormInput';
import { useFormContext, get } from 'react-hook-form';
import { CustomErrorMessage } from 'form/components/CustomErrorMessage/CustomErrorMessage';
import { InjectableContent, Help } from 'form/components/InputWrapper/InputWrapper';
import useCustomValidation from 'form/infrastructure/reactHookForm/hooks/useCustomValidation';

type Props = {
  name: string;
  title: string;
  children: any;
  customErrorMessages?: CustomErrorMessage[];
  isOptional?: boolean;
  extraContent?: InjectableContent[];
  state?: FormInput['state'];
  showMultipleErrors?: boolean;
  help?: Help;
  style?: React.CSSProperties;
  isNested?: boolean;
  newUi?: boolean;
};

const FormInputWrapper: React.FC<Props> = ({
  name,
  title,
  children,
  customErrorMessages,
  isOptional = false,
  extraContent,
  state,
  showMultipleErrors = false,
  help,
  style,
  isNested = false,
  newUi = false,
}) => {
  const [context, shouldShowError] = useCustomValidation();

  const {
    formState: { errors },
  } = useFormContext<any>();

  return (
    <InputWrapper
      name={name}
      title={title}
      help={help}
      error={get(errors, name)}
      customErrorMessages={customErrorMessages}
      customValidation={{ context, shouldShowError }}
      isOptional={isOptional}
      extraContent={extraContent}
      showMultipleErrors={showMultipleErrors}
      style={style}
      isNested={isNested}
      newUi={newUi}>
      {React.cloneElement(children, {
        name,
        state: Boolean(get(errors, name)) ? 'error' : state,
      })}
    </InputWrapper>
  );
};

export default FormInputWrapper;
